import { Component } from '@angular/core';
import { ColmecDiscount } from '../../../services/colmec-discounts.service';
import { ListItemRendererComponent } from 'gung-list';

@Component({
    selector: 'colmec-discount-list-view',
    templateUrl: './colmec-discount-list-view.component.html',
    styleUrls: ['./colmec-discount-list-view.component.scss'],
    standalone: false
})
export class ColmecDiscountListViewComponent extends ListItemRendererComponent<ColmecDiscount[]>{

}
